import { render, staticRenderFns } from "./UserRequestsList.vue?vue&type=template&id=46106bec&"
import script from "./UserRequestsList.vue?vue&type=script&lang=js&"
export * from "./UserRequestsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports